import React from 'react';
import './ServicesPage.css';

const services = [
  { icon: '🎓', title: 'University Selection', desc: 'We match you with the best Malaysian university based on your academic background, course preference, budget, and career goals.', points: ['Personalised counselling sessions', 'Compare 52+ universities', 'Programme & fees guidance', 'Campus visit coordination'] },
  { icon: '📋', title: 'Application Assistance', desc: 'Our team handles your entire application from document collection to submission, ensuring everything is correct and complete.', points: ['Document checklist & preparation', 'Application form filling', 'Personal statement review', 'Submission tracking'] },
  { icon: '🛂', title: 'Student Visa (RM Pass)', desc: 'We guide you through the Malaysia Student Visa (RM Pass) process — one of the most important steps in your journey.', points: ['Visa requirements checklist', 'iKad application assistance', 'Medical check guidance', 'Visa tracking & follow-up'] },
  { icon: '🏆', title: 'Scholarship Guidance', desc: 'We help you find and apply for scholarships and financial aid so education costs don\'t hold you back.', points: ['Scholarship search & eligibility', 'Application support', 'Essay & letter coaching', 'Alternative funding advice'] },
  { icon: '🏠', title: 'Accommodation Support', desc: 'Finding a safe, affordable place to stay is crucial. We connect you with verified hostels and apartments near your campus.', points: ['University hostel assistance', 'Private apartment options', 'Budget planning for rent', 'Roommate matching'] },
  { icon: '✈️', title: 'Pre-Departure Briefing', desc: 'Our detailed pre-departure session prepares you for life in Malaysia — from climate and culture to currency and transport.', points: ['What to pack checklist', 'Malaysia cultural briefing', 'Airport pickup coordination', 'SIM card & bank account guidance'] },
  { icon: '📞', title: 'Post-Arrival Support', desc: 'We don\'t disappear after you land. Our team stays with you through registration, orientation, and settling in.', points: ['Registration assistance', 'Orientation guidance', 'Emergency contact support', 'Ongoing WhatsApp assistance'] },
  { icon: '💼', title: 'Career & Internship Guidance', desc: 'Plan your career while studying. We provide guidance on internships, part-time work, and post-study pathways in Malaysia.', points: ['Career counselling sessions', 'Internship search help', 'Work permit guidance', 'Post-study pathway planning'] },
];

export default function ServicesPage() {
  return (
    <div className="srv-page">
      <div className="srv-hero">
        <div className="srv-hero-inner">
          <span className="section-tag">What We Offer</span>
          <h1 className="srv-title">Our <span className="gold-text">Services</span></h1>
          <p className="srv-sub">From university selection to post-arrival support — StudiLine is with you every step of your Malaysian university journey. All services are FREE for students.</p>
          <div className="srv-free-badge">🎉 All Services Are 100% Free for Students</div>
        </div>
      </div>

      <div className="srv-body">
        <div className="srv-grid">
          {services.map((s, i) => (
            <div key={i} className="srv-card" style={{ animationDelay: `${i * 0.06}s` }}>
              <div className="srv-icon">{s.icon}</div>
              <h3 className="srv-name">{s.title}</h3>
              <p className="srv-desc">{s.desc}</p>
              <ul className="srv-points">
                {s.points.map((p, j) => (
                  <li key={j}><span className="srv-check">✓</span>{p}</li>
                ))}
              </ul>
              <a
                href={`https://wa.me/601169479883?text=Hi! I need help with: ${s.title}`}
                target="_blank"
                rel="noopener noreferrer"
                className="srv-cta"
              >
                💬 Enquire Now
              </a>
            </div>
          ))}
        </div>

        <div className="srv-process">
          <h2 className="srv-process-title">How It <span className="gold-text">Works</span></h2>
          <div className="srv-steps">
            {[
              { num: '01', title: 'Contact Us', desc: 'WhatsApp or email us with your details and goals.', icon: '💬' },
              { num: '02', title: 'Free Consultation', desc: 'We assess your profile and recommend the best universities.', icon: '🎓' },
              { num: '03', title: 'Application', desc: 'We prepare and submit your application on your behalf.', icon: '📋' },
              { num: '04', title: 'Visa & Travel', desc: 'We guide your visa process and pre-departure preparation.', icon: '✈️' },
              { num: '05', title: 'Arrive & Settle', desc: 'We support you on arrival and throughout your studies.', icon: '🏠' },
            ].map((step, i) => (
              <div key={i} className="srv-step">
                <div className="srv-step-num">{step.num}</div>
                <div className="srv-step-icon">{step.icon}</div>
                <h4 className="srv-step-title">{step.title}</h4>
                <p className="srv-step-desc">{step.desc}</p>
                {i < 4 && <div className="srv-step-arrow">→</div>}
              </div>
            ))}
          </div>
        </div>

        <div className="srv-cta-box">
          <h2>Ready to Start Your Journey?</h2>
          <p>Join hundreds of students who have successfully enrolled in Malaysian universities through StudiLine.</p>
          <div className="srv-cta-btns">
            <a href="https://wa.me/601169479883?text=Hi! I want to start my Malaysian university application." target="_blank" rel="noopener noreferrer" className="srv-wa-cta">
              💬 Start on WhatsApp
            </a>
            <a href="mailto:studiline.bd@gmail.com" className="srv-email-cta">
              📧 studiline.bd@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
